import { AfterViewInit, Component, Input } from '@angular/core';
import { EChartsOption } from 'echarts';
import { IRiskStatusGraph } from 'src/app/models/incident';
import * as echarts from 'echarts';

@Component({
  selector: 'app-risk-breakdown-graph',
  templateUrl: './risk-breakdown-graph.component.html',
  styleUrl: './risk-breakdown-graph.component.scss',
})
export class RiskBreakdownGraphComponent implements AfterViewInit {
  @Input() set breakdownRiskData(val: IRiskStatusGraph[]) {
    if (val) {
      if (val.length > 0) {
        this.riskData = val;
        this.initChart();
      }
    }
  }
  @Input() set chartHeight(val: any) {
    if (val) this.height = val + 'px';
  }
  riskData: IRiskStatusGraph[] = [];
  height = '';
  chartOption: EChartsOption;
  chartInstance: any;
  ngAfterViewInit() {
    // Initialize the chart after the view has been fully initialized
    this.initChart();
  }
  private initChart() {
    if (this.riskData.length === 0 || !document.getElementById('chart')) {
      return;
    }
    this.setChartData(this.riskData);
  }
  private setChartData(val: IRiskStatusGraph[]) {
    const sortedDate = val
      .slice()
      .sort(
        (a, b) =>
          new Date(a.eventDate).getTime() - new Date(b.eventDate).getTime()
      );

    const dates = sortedDate.map((item) =>
      new Date(item.eventDate).toLocaleString('en-US')
    );
    const open = sortedDate.map((item) => item.open);
    const closed = sortedDate.map((item) => item.closed);
    const verified = sortedDate.map((item) => item.verified);
    const snoozed = sortedDate.map((item) => item.snoozed);
    const inProgress = sortedDate.map((item) => item.inProgress);
    const onHold = sortedDate.map((item) => item.onHold);
    const approved = sortedDate.map((item) => item.approved);
    const rejected = sortedDate.map((item) => item.rejected);

    const combinedArray = [
      ...open,
      ...closed,
      ...verified,
      ...snoozed,
      ...inProgress,
      ...onHold,
      ...approved,
      ...rejected,
    ];
    const maxVal = Math.max(...combinedArray);

    this.chartOption = {
      tooltip: {
        trigger: 'axis',
      },
      legend: {
        data: [
          'Open',
          'Closed',
          'Verified',
          'Snoozed',
          'In-Progress',
          'On-Hold',
          'Approved',
          'Rejected',
        ],
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: dates,
        axisLabel: {
          rotate: dates.length > 8 ? 45 : 0,
          formatter: (value: string) => {
            const date = new Date(value);
            const month = date.toLocaleString('en-us', { month: 'short' });
            const day = date.getDate();
            return `${month} ${day}`;
          },
        },
      },
      yAxis: {
        type: 'value',
        min: 0,
        max: maxVal + 10,
      },
      series: [
        { name: 'Open', type: 'line', data: open },
        { name: 'Closed', type: 'line', data: closed },
        { name: 'Verified', type: 'line', data: verified },
        { name: 'Snoozed', type: 'line', data: snoozed },
        { name: 'In-Progress', type: 'line', data: inProgress },
        { name: 'On-Hold', type: 'line', data: onHold },
        { name: 'Approved', type: 'line', data: approved },
        { name: 'Rejected', type: 'line', data: rejected },
      ],
      dataZoom: [
        { type: 'slider', show: true, xAxisIndex: [0], start: 0, end: 100 },
        { type: 'inside', xAxisIndex: [0], start: 0, end: 100 },
      ],
    };

    // const chartInstance = echarts.init(
    //   document.getElementById('chart') as HTMLElement
    // );
    const chartElement = document.getElementById('chart') as HTMLElement;
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
    this.chartInstance = echarts.init(chartElement);
    this.chartInstance.setOption(this.chartOption);

    // Add event listener for data zoom
    this.chartInstance.on('datazoom', (params: any) => {
      const start = params.start / 100;
      const end = params.end / 100;
      const startIndex = Math.floor(start * dates.length);
      const endIndex = Math.floor(end * dates.length);

      const visibleOpen = open.slice(startIndex, endIndex + 1);
      const visibleClosed = closed.slice(startIndex, endIndex + 1);
      const visibleVerified = verified.slice(startIndex, endIndex + 1);
      const visibleSnoozed = snoozed.slice(startIndex, endIndex + 1);
      const visibleInProgress = inProgress.slice(startIndex, endIndex + 1);
      const visibleOnHold = onHold.slice(startIndex, endIndex + 1);
      const visibleApproved = approved.slice(startIndex, endIndex + 1);
      const visibleRejected = rejected.slice(startIndex, endIndex + 1);

      const visibleCombinedArray = [
        ...visibleOpen,
        ...visibleClosed,
        ...visibleVerified,
        ...visibleSnoozed,
        ...visibleInProgress,
        ...visibleOnHold,
        ...visibleApproved,
        ...visibleRejected,
      ];
      const newMaxVal = Math.max(...visibleCombinedArray);

      // Update the yAxis max value dynamically
      this.chartInstance.setOption({
        yAxis: {
          max: newMaxVal + 10,
        },
      });
    });
  }
}
